<template>
  <div class="page-container">
    <!-- Bütün sayfayı kaplayan loading ekranı -->
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>

    <div class="row" v-show="!loading">
      <div class="container">
        <vue-good-table
            mode="remote"
            :rows="rows"
            :columns="columns"
            :line-numbers="true"
        >
          <div slot="table-actions">
            <b-button block class="mt-2" variant="success" @click="resetAddForm(); showAddModal = true">+ Uyarı Ekle</b-button>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'actions'">
              <div class="d-flex justify-content-center gap-2 px-2">
                <b-button variant="danger" @click.prevent="deleteWarning(props.formattedRow.id)">Sil</b-button>
              </div>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
    <!-- Uyarı Ekle Modalı -->
    <b-modal v-model="showAddModal" title="Yeni Uyarı Ekle" @ok="createWarning">
      <b-form-group label="İşletmeler">
        <multiselect
            v-model="selectedClients"
            :options="clients"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="true"
            :preserve-search="true"
            track-by="id"
            label="name"
            placeholder="İşletme seçin"
        />
      </b-form-group>

      <b-form-group label="Uyarı Metni">
        <b-form-input v-model="newWarningText" required />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import WarningService from "@/service/WarningService";
import ClientService from "@/service/ClientService";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: 'warning-list',
  components: {
    Multiselect, 
  },
  data() {
    return {
      loading: false,  // ✅ Sayfa yükleniyor mu?
      columns: [
        {
          field: 'id',
          hidden: true
        },
        {
          field: 'clientId',
          hidden: true,
        },
        {
          label: 'İşletme Adı',
          field: 'clientName',
          sortable: false,
        },
        {
          label: 'Uyarı',
          field: 'text',
          sortable: false,
        },
        {
          field: 'actions',
          sortable: false,
        }
      ],
      rows: [],
      showAddModal: false,
      newWarningText: '',
      clients: [],
      selectedClients: [],
    };
  },
  methods: {
    async loadItems() {
      this.loading = true;
      try {
        this.rows = await WarningService.list();
      } catch (error) {
        console.error("Listeleme sırasında hata oluştu:", error);
      } finally {
        this.loading = false;
      }
    },

    async deleteWarning(id) {
      this.loading = true;  // ✅ Sayfa yükleniyor
      try {
        await WarningService.delete(id);
        await this.loadItems(this.serverParams);  // Güncellemeden sonra listeyi yenile
        this.$notification(this, "Uyarı başarıyla silindi.");
      } catch (error) {
        console.error("Uyarı silinirken hata oluştu:", error);
        this.$errorNotification(this, "Uyarı silinirken hata oluştu.");
      } finally {
        this.loading = false; // ✅ İşlem bittiğinde kaldır
      }
    },

    async createWarning() {
      if (!this.newWarningText || this.selectedClients.length === 0) return;
      this.loading = true;
      try {
        await WarningService.create({ clientIds: this.selectedClients.map(c => c.id), text: this.newWarningText });
      } catch (error) {
        this.$alert(this, error.message);
      } finally {
        this.loading = false;
      }
      this.newWarningText = '';
      this.showAddModal = false;
      await this.loadItems();
    },
    async loadClients() {
      try {
        const requestBody = {
          columnFilters: {},
          page: 1,
          perPage: 10000,
          sortField: 'name',
          sortDirection: 'asc',
        };
        const response = await ClientService.list(requestBody);
        this.clients = response.data.map(item => ({
          ...item,
          name: item.shortName ? `${item.shortName} (${item.name})` : item.name
        })) || [];
      } catch (error) {
        console.error("İşletme listesi alınırken hata oluştu:", error);
        this.$errorNotification &&
        this.$errorNotification(this, "İşletme listesi alınırken hata oluştu.");
      }
    },
    resetAddForm() {
      this.selectedClients = [];
      this.newWarningText = '';
    },
  },
  async mounted() {
    await this.loadItems();
    await this.loadClients();
  }
};
</script>

<style>
/* Sayfanın üstüne loading efekti ekleyen CSS */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Yarı saydam beyaz */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1000;
  font-size: 20px;
}

.cursor-pointer {
  cursor: pointer;
}

.multiselect__tags {
  max-height: none !important;
  overflow-y: visible !important;
}
</style>
